import { render, staticRenderFns } from "./PersonaHeader.vue?vue&type=template&id=befd0182&scoped=true"
import script from "./PersonaHeader.vue?vue&type=script&lang=js"
export * from "./PersonaHeader.vue?vue&type=script&lang=js"
import style0 from "./PersonaHeader.vue?vue&type=style&index=0&id=befd0182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befd0182",
  null
  
)

export default component.exports